import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getMassBalance47Totals } from "../../../../../apis/Product/MassBalanceFlow47Api";

// Mass Balance icon
const MassBalanceIcon = () => (
  <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M38 10L20 25V35C20 45 25 55 38 60C51 55 56 45 56 35V25L38 10Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 38L38 43L56 38" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38 43V60" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MassBalanceHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalMassBalance, setTotalMassBalance] = useState(null);

  const fetchTotals = useCallback(() => {
    if (!productId) return;
    getMassBalance47Totals({
      productId,
      setObjects: (data) => {
        setTotalMassBalance(data);
      },
    });
  }, [productId]);

  useEffect(() => {
    fetchTotals();
    const interval = setInterval(fetchTotals, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`mass-balance-47-category ${className || ""}`}
      leftBoxProps={{
        icon: <MassBalanceIcon />,
        title: t("MASS_BALANCE") || "Mass Balance",
        description:
          t("MASS_BALANCE_DESC") ||
          "Complete material mass balance across all lifecycle phases. Validates that total input mass equals total output mass for data integrity and traceability. Blue = inputs, Red = outputs.",
        productId: productId,
        isSystemBoundary: false,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_MASS_BALANCE") || "Total Mass Balance",
            items: [
              {
                subtitle: t("INPUTS") || "Inputs",
                subitems: [
                  {
                    value: totalMassBalance?.total_inputs != null
                      ? `${Number(totalMassBalance.total_inputs).toFixed(2)} kg`
                      : "xx kg",
                  },
                ],
              },
              {
                subtitle: t("OUTPUTS") || "Outputs",
                subitems: [
                  {
                    value: totalMassBalance?.total_outputs != null
                      ? `${Number(totalMassBalance.total_outputs).toFixed(2)} kg`
                      : "xx kg",
                  },
                ],
              },
              {
                subtitle: t("BALANCE_GAP") || "Balance Gap",
                subitems: [
                  {
                    value: totalMassBalance?.balance_gap != null && totalMassBalance?.balance_gap_percent != null
                      ? `${Number(totalMassBalance.balance_gap).toFixed(2)} kg (${Number(totalMassBalance.balance_gap_percent).toFixed(2)}%)`
                      : "xx kg",
                  },
                ],
              },
            ],
            isSwitchable: false,
          },
        ],
        impactTotals: null,
        lastUpdated: totalMassBalance?.updated_at
          ? formatDate(totalMassBalance.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
    />
  );
};

export default MassBalanceHeader;

